<template>
  <div id="center" class="ml-1 mt-1 bg-color-black">
    <el-tag class="coreTitle mt-1 pb-1">2024年公司业务情况</el-tag>
    <div class="up">
      <div ref="chartContainer" style="height: 100%;"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";

export default {
  name: "companyYearChart",
  mixins: [autoResize],
  props: [],
  data() {
    return {

    }
  },
  watch: {

  },
  components: {
  },
  methods: {
    initChart() {
      const dom = this.$refs.chartContainer;
      this.myChart = echarts.init(dom, 'dark', {
        renderer: 'canvas',
        useDirtyRect: false,
      });

      const option = {
        backgroundColor: '',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        grid:{ // 让图表占满容器
          top:"25",
          left:"30",
          right:"40",
          bottom:"25"
        },
        // legend: {
        //   data: ['Precipitation', 'Temperature'],
        // },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisLabel: {
              interval: 0,
              textStyle: {
                fontSize : 15      //更改坐标轴文字大小
              }
            }
          },
        ],
        yAxis: [
          {
            type: 'value',
            // min: 0,
            // max: 250,
            // interval: 50,

          },
          {
            type: 'value',
            // name: 'Temperature',
            // max: 25,
            // interval: 5,

          },
        ],
        series: [
          {
            name: '预计',
            data: [112, 115, 149,126, 228, 270, 375, 325, 0,0,0,0],
            type: 'pictorialBar', // 象形柱图
            symbol: 'triangle', // 三角形
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: '#00fbfa',
                },
                {
                  offset: 1,
                  color: 'rgba(0, 251, 250, 0.31)',
                },
              ],
            },
          },
          {
            name: '实际',
            type: 'line',
            yAxisIndex: 1,
            symbol: 'emptyCircle',     //设定为实心点
            symbolSize: 12,   //设定实心点的大小
            smooth: true,
            data: [212, 222, 233, 244, 266, 310, 420, 155, 0,0,0,0],
            itemStyle: {
              // 设置线条上点的颜色（和图例的颜色）
              normal: {
                color: '#50c609',
              },
            },
            lineStyle: {
              normal: {
                color: '#50c609',
              },

            }
          },

        ],
      };
        this.myChart.setOption(option);
    },
  },
  mounted() {
    this.initChart();
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 180px;
  flex-wrap: nowrap;
  .coreTitle {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
  .up {
    width: 100%;
    height: 150px;
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
